<style lang="less" scoped>
  .present-cover {
    display: flex;
    align-items: center;

    > div {
      display: flex;
      align-items: center;
    }

    > div:nth-of-type(1) {
      flex-direction: column;
      align-items: flex-start;
      flex: 1;
      padding-right: 8px;

      .present-cost {
        margin-top: 2px;
        color: #8492a6;
      }
    }

    > div:nth-of-type(2) {
      padding-right: 8px;
    }

    .present-delete-btn {
      width: 40px;
      height: 40px;
      display: flex;
      align-items: center;
      justify-content: center;
      img {
        width: 16px;
      }
    }
  }
  .description {
    color: gray;
    padding-left: 5px;
    font-size: .9em;
  }
  .present-unit-input {
    width: 128px;
  }
</style>

<template lang="pug">
  .present-cover(v-loading="isLoading")
    div
      .present-title {{name}}
        span.description {{description}}
      .present-cost &#8361; {{price}}/g
    div
      el-input.present-unit-input(v-model="ingredient.amount" v-if="!unavailable")
        template(slot="append") g
      span(:style="{ color: 'red' }" v-else) 재고 없음
    div
      el-button.present-delete-btn(v-on:click="deleteIngredient")
        img(src="@/assets/trash-red-small@2x.png")

</template>

<script>
export default {
  props: ['ingredient'],
  data() {
    return {
      name: null,
      price: null,
      description: null,
      unavailable: true,
      isLoading: false,
    };
  },
  methods: {
    deleteIngredient() {
      this.$emit('deleteIngredient', this.initSimpleInfo());
    },
    async findIngredientById(objectId) {
      this.isLoading = true;
      try {
        const { data } = await this.$http.get('/ingredients/'.concat(objectId));
        this.name = data.name;
        this.price = data.price;
        this.unavailable = data.unavailable;
        this.description = data.description;
        if (data.unavailable === true) {
          this.ingredient.amount = 0;
        }
      } catch (e) {
        alert('약재정보를 불러올 수 없었습니다.');
      }
      this.isLoading = false;
    },
    initSimpleInfo() {
      return { id: this.ingredient.ingredient, amount: this.ingredient.amount, price: this.price };
    },
  },
  watch: {
    async ingredient() {
      // 중간에 존재하는 약재가 삭제되면 한번 받아온 약재 정보가 변동이 안되기 때문에
      // 약재가 삭제되어도 마지막에 있는 약재가 지워지는 것 처럼 보여짐.
      // 그래서 ingredient의 변화에 따라서 한 번 더 약재 정보를 받아서 덮어 씌움.
      await this.findIngredientById(this.ingredient.ingredient);
    },
    'ingredient.amount': {
      deep: true,
      handler() {
        this.$emit('update', this.initSimpleInfo());
      },
    },
  },
  async mounted() {
    await this.findIngredientById(this.ingredient.ingredient);
    this.$emit('update', this.initSimpleInfo());
  },
};
</script>



// WEBPACK FOOTER //
// src/components/present.vue